import { matchesX } from './utils';
export default function makeScaledBarGroups(series, xScale, plotWidth, plotHeight, axis) {
    if (!xScale.isCategorical()) {
        return [];
    }
    return xScale.domain.map(function (x) {
        var scaledX = xScale.d3Scale(x);
        var isValid = typeof scaledX !== 'undefined' && isFinite(scaledX);
        return {
            x: x,
            isValid: isValid,
            hasData: series.some(function (_a) {
                var series = _a.series;
                if (series.type === 'threshold') {
                    return true;
                }
                return series.data.some(function (datum) { return matchesX(datum.x, x); });
            }),
            position: axis === 'x'
                ? {
                    x: 0,
                    y: isValid ? scaledX || 0 : 0,
                    width: plotWidth,
                    height: xScale.d3Scale.bandwidth()
                }
                : {
                    x: isValid ? scaledX || 0 : 0,
                    y: 0,
                    width: xScale.d3Scale.bandwidth(),
                    height: plotHeight
                }
        };
    });
}
